export const buildReportFileName = (
  id: number | string,
  name: string,
  suffix: string
): string => {

  const cleanId = String(id).trim();
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const cleanName = (name ?? '').trim() || "Unnamed";

  return `${cleanId}_${cleanName}_${suffix}.csv`;
};
